import React, { Component } from 'react';
import Select from 'react-select';
import { Input, FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';

class SelectSimple extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOption: this.props.value || null,
        };
    }

    static propTypes = {
        name: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.any.isRequired,
                label: PropTypes.string.isRequired,
            })
        ).isRequired,
        value: PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
        }),
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        clearable: PropTypes.bool,
    };

    static defaultProps = {
        value: null,
        disabled: false,
        clearable: true,
        onChange: () => {},
    };

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                selectedOption: this.props.value || null
            });
        }
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption });

        if (this.props.onChange) {
            this.props.onChange(selectedOption);
        }
    };

    render() {
        const {
            name,
            options,
            disabled,
            clearable,
        } = this.props;
        const { selectedOption } = this.state;

        return (
            <React.Fragment>
                <Select
                    options={options}
                    value={selectedOption}
                    onChange={this.handleChange}
                    disabled={disabled}
                    clearable={clearable}
                    getOptionValue={(option) => option.value}
                    getOptionLabel={(option) => option.label}
                    placeholder="Seleccionar..."
                />

                {/* Este Input es únicamente para poder mostrar errores del FormFeedback.
                    El componente Select sí tiene el mismo estilo visual que lo usado en ParadigmaAsyncSeeker
                    pero pertenecen a una libreria ajena a la de reacstrap por lo tanto son incompatibles el
                    Select con FormFeedback para mostrar errores, la solucion es usar Input que viene de la
                    libreria de reacstrap, pero dejarlo invisible*/}
                <Input
                    name={name}
                    value={selectedOption ? selectedOption.value : ""}
                    className="d-none"
                    type={'text'}
                    disabled={disabled}
                />
                <FormFeedback className="col-12"></FormFeedback>
            </React.Fragment>
        );
    }
}

export default SelectSimple;



// WEBPACK FOOTER //
// ./src/components/SelectSimple/SelectSimple.js